export default "__VITE_ASSET__CIeDYRdW__"